import { css } from '@emotion/core';

const passwordContainerStyleOverrides = css`
  margin-bottom: 12px;
`;

export { passwordContainerStyleOverrides };
